import clsx from 'clsx';

import Box from './box';
import { BoxElement } from './types';

const ChatInputBlock = ({ children, className, ...props }: BoxElement) => {
  return (
    <Box {...props} className={clsx('bg-white rounded-md', className)}>
      {children}
    </Box>
  );
};

export default ChatInputBlock;
